/**
 * Demos Color Theme
 *
 * Primary color palette based on Volt purple branding (#502378)
 * Designed for accessibility and visual hierarchy
 */

const colors = {
  // Primary Brand Colors
  primary: {
    main: '#502378',        // Main brand purple (Volt)
    dark: '#3d1a5c',        // Darker purple for hover states
    light: '#7a4fa3',       // Lighter purple for secondary actions
    lighter: '#a584c4',     // Even lighter for subtle elements
    pale: '#e2d5ef',        // Very light for backgrounds/borders
  },

  // Lila / light purple highlight (used for badges, subtle highlights)
  lila: {
    bg: '#e2d5ef',          // Lila background highlight
    text: '#502378',        // Purple text on lila background
  },

  // Rank badge (light gray circular #1/#2 badges, e.g. THEMA cards)
  rankBadge: {
    bg: '#e2e8f0',          // Light gray background (gray.200)
    text: '#4a5568',        // Dark gray text (gray.700)
  },

  // Background Colors
  background: {
    main: '#faf8fc',        // Main page background (warm white)
    white: '#ffffff',       // Pure white for cards/boxes
    light: '#f7f3fb',       // Slightly warmer than main
    gray: '#f7f7f7',        // Neutral gray for contrast
  },

  // Text Colors
  text: {
    primary: '#2d3748',     // Dark gray for main text
    secondary: '#718096',   // Medium gray for secondary text
    muted: '#a0aec0',       // Light gray for muted text
    white: '#ffffff',       // White text on dark backgrounds
    link: '#502378',        // Links use primary color
    linkHover: '#3d1a5c',   // Link hover state
  },

  // UI Element Colors
  ui: {
    border: '#e2e8f0',      // Light gray for borders
    borderHover: '#cbd5e0', // Slightly darker for hover
    shadow: 'rgba(80, 35, 120, 0.1)', // Subtle purple shadow
    overlay: 'rgba(0, 0, 0, 0.5)', // Dark overlay for modals
  },

  // Status Colors (semantic)
  status: {
    success: '#38a169',     // Green for success states
    successLight: '#c6f6d5', // Light green background
    error: '#e53e3e',       // Red for errors
    errorLight: '#fed7d7',  // Light red background
    warning: '#dd6b20',     // Orange for warnings
    warningLight: '#feebc8', // Light orange background
    info: '#3182ce',        // Blue for info
    infoLight: '#bee3f8',   // Light blue background
  },

  // Button Colors
  button: {
    primary: '#502378',
    primaryHover: '#3d1a5c',
    primaryActive: '#2e1345',
    secondary: '#7a4fa3',
    secondaryHover: '#693f92',
    secondaryActive: '#583181',
    ghost: 'transparent',
    ghostHover: '#f7f3fb',
    disabled: '#cbd5e0',
    disabledText: '#a0aec0',
  },

  // Sidebar Colors - Light design with strategic purple accents
  sidebar: {
    background: '#ffffff',        // White sidebar background
    hover: '#f7f3fb',            // Very light purple tint on hover
    active: '#f7f3fb',           // Light purple background when active
    activeText: '#502378',       // Purple text when active
    activeBorder: '#502378',     // Purple left border for active item
    text: '#2d3748',             // Dark gray text
    textHover: '#502378',        // Purple text on hover
    border: '#e2e8f0',           // Light gray border
    logoBg: '#502378',           // Purple background for logo area
    logoAccent: '#502378',       // Purple accent for branding
    divider: '#e2e8f0',          // Light gray divider
  },

  // Navigation Colors
  navigation: {
    background: '#ffffff',
    border: '#e2e8f0',
    text: '#2d3748',
    icon: '#718096',
    iconHover: '#502378',
  },

  // Card Colors
  card: {
    background: '#ffffff',
    border: '#e2e8f0',
    shadow: 'rgba(0, 0, 0, 0.05)',
    hover: '#f7f3fb',
  },

  // Form Colors
  form: {
    inputBg: '#ffffff',
    inputBorder: '#e2e8f0',
    inputBorderFocus: '#502378',
    inputText: '#2d3748',
    inputPlaceholder: '#a0aec0',
    label: '#2d3748',
    error: '#e53e3e',
    errorBg: '#fed7d7',
  },

  // Table Colors
  table: {
    headerBg: '#f7f7f7',
    rowBg: '#ffffff',
    rowHover: '#f7f3fb',
    border: '#e2e8f0',
  },
}

// Export individual color groups for convenience
export const primaryColors = colors.primary
export const backgroundColors = colors.background
export const textColors = colors.text
export const uiColors = colors.ui
export const statusColors = colors.status
export const buttonColors = colors.button
export const sidebarColors = colors.sidebar
export const navigationColors = colors.navigation
export const cardColors = colors.card
export const formColors = colors.form
export const tableColors = colors.table

// Export full color object as default
export default colors
